import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fw-medium text-dark" }
const _hoisted_11 = { class: "fw-semibold text-primary" }
const _hoisted_12 = { class: "d-flex align-items-center gap-1" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Translate Price Tiers",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, [
            _createElementVNode("h5", { class: "mb-1 fs-15" }, "Pricing Tiers"),
            _createElementVNode("p", { class: "text-muted fs-13 mb-0" }, "Manage page-range based pricing for the Translate service.")
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/translate-price-tiers/create",
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                _createElementVNode("span", null, "Add New Tier")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "ID"),
                  _createElementVNode("th", { scope: "col" }, "Label"),
                  _createElementVNode("th", { scope: "col" }, "Min Pages"),
                  _createElementVNode("th", { scope: "col" }, "Max Pages"),
                  _createElementVNode("th", { scope: "col" }, "Price"),
                  _createElementVNode("th", { scope: "col" }, "Status"),
                  _createElementVNode("th", { scope: "col" }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[2] || (_cache[2] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.tiers.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[3] || (_cache[3] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "text-center py-4"
                        }, "No pricing tiers found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.tiers, (tier) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: tier.id
                        }, [
                          _createElementVNode("td", null, "#" + _toDisplayString(tier.id), 1),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(tier.label || '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(tier.min_pages), 1),
                          _createElementVNode("td", null, _toDisplayString(tier.max_pages ?? '∞'), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatPrice(tier.price)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge p-2 fs-12 fw-normal", tier.is_active ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                            }, _toDisplayString(tier.is_active ? 'Active' : 'Inactive'), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_RouterLink, {
                                to: `/translate-price-tiers/${tier.id}/edit`,
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deleteTier(tier.id)),
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, _cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                              ]), 8, _hoisted_13)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}